import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const YUSD_URL = 'https://ctrl.yield.fi/t/yusd/apy'
const yusd = 'YieldFi yUSD::yUSD'

export const yusdFetcher: YieldFetcher = {
  label: 'YUSD',
  fetch: async () => {
    const res = await fetch(YUSD_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    return { [yusd]: apyToAprPercent(Number(res?.apy ?? 0)) }
  },
}
